import { render, staticRenderFns } from "./system-event.vue?vue&type=template&id=67081148&scoped=true"
import script from "./system-event.vue?vue&type=script&lang=js"
export * from "./system-event.vue?vue&type=script&lang=js"
import style0 from "./system-event.vue?vue&type=style&index=0&id=67081148&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67081148",
  null
  
)

export default component.exports